import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';


import '@components/ui/browser-notice/browser-notice';
import { initAllPlayers } from '@components/ui/vimeo-player/vimeo-player';
import '@components/ui/vimeo-overlay/vimeo-overlay';
import '@components/sections/header/header';
import '@components/sections/features/features';
import '@components/sections/testimonials/testimonials';
import '@components/sections/specifications/specifications';
import '@components/sections/brochure/brochure';
import '@components/sections/stay-informed/stay-informed';
import '@components/sections/capacity/capacity';
// import '@components/sections/lineup/lineup';

gsap.registerPlugin(ScrollToPlugin);

// Global smooth-scroll.
const hashedAnchors = document.querySelectorAll('a[href^="#"');
Array.from(hashedAnchors).forEach((anchor) => {
  if (anchor.hash.length) {
    anchor.addEventListener('click', (e) => {
      e.preventDefault();
      gsap.to(window, {
        scrollTo: {
          y: anchor.hash,
          offsetY: -10,
        },
        duration: 0.3,
      });
    });
  }
});

// Smooth scroll to anchor from external page/email.
window.addEventListener('load', (event) => {
  const path = window.location;
  if (path.hash) {
    gsap.to(window, {
      scrollTo: {
        y: path.hash,
        offsetY: -10,
      },
      duration: 0.3,
    });
  }
});
// Vimeo players!
initAllPlayers();
